import { MapContext } from 'contexts/MapContext';
import * as RiIcons from 'react-icons/ri';
import React, { useContext, useMemo, useEffect, useState } from 'react';
import * as Styled from './styles';
import { useLayers } from 'hooks/useLayers';
import VectorLayer from 'ol/layer/Vector';
import { ToolBox } from 'screens/Dashboard/components/SideBar/ToolBox';
import { BaseSelect } from 'components/BaseSelect';
import { getVectorLayerAttributes } from 'utils/vectorLayerAttributes';

function getName(str: string) {
  const key = 'p3m:';
  const index = str?.indexOf(key);
  return index !== -1 ? 'p3m:' + str?.slice(index + key.length) : '';
}

function getLayerId(layer: any): string {
  const props = layer?.getProperties?.() ?? {};
  if (props.layertitle) return String(props.layertitle);
  if (props.uuid) return String(props.uuid);
  return '';
}

export function DissolveLayersMenu() {
  const { getLayerAttritubeByName } = useLayers();

  const {
    map,
    dissolveLayer,
    dissolveAttribute,
    handleSetDissolveLayer,
    handleSetDissolveAttribute,
    handleApplyDissolveLayer,
  } = useContext(MapContext);

  const [layersVersion, setLayersVersion] = useState(0);

  useEffect(() => {
    if (!map) return;

    const layers = map.getLayers();

    const onAdd = () => {
      setLayersVersion(v => v + 1);
    };

    layers.on('add', onAdd);

    return () => {
      layers.un('add', onAdd);
    };
  }, [map]);

  const vectorLayers = useMemo(() => {
    if (!map) return [];

    return map.getLayers().getArray().filter((layer: any) => {
      if (!(layer instanceof VectorLayer)) return false;

      const props = layer?.getProperties?.() ?? {};
      return !!(props.layertitle || props.uuid);
    });
  }, [map, layersVersion]);

  const selectedId = dissolveLayer ? getLayerId(dissolveLayer) : '';

  const dissolveAttributes = useMemo(() => {
    if (!dissolveLayer) return [];

    const source = dissolveLayer.getSource();
    if (!source) return [];

    return getVectorLayerAttributes({
      atributos: [],
      vector_source: source,
    });
  }, [dissolveLayer]);

  function getLayerLabel(layer: any) {
    const id = getLayerId(layer);
    const meta = getLayerAttritubeByName(getName(id))?.layertitle || id;
    return meta.replace(/\.(kml|geojson|zip|shp)$/i, '');
  }

  return (
    <ToolBox
      header={
        <>
          <RiIcons.RiShape2Line />
          <span>Dissolver Polígonos</span>
        </>
      }
    >
      <BaseSelect
        label='Camada vetorial'
        value={selectedId || 'disable'}
        onChange={handleSetDissolveLayer}
        placeholder='Selecione a camada'
        options={vectorLayers.map(l => ({
          label: getLayerLabel(l),
          value: getLayerId(l),
        }))}
      />

      <BaseSelect
        label='Atributo'
        value={dissolveAttribute || 'disable'}
        onChange={handleSetDissolveAttribute}
        placeholder='Dissolver todas as feições'
        disabled={!dissolveLayer || dissolveAttributes.length === 0}
        options={dissolveAttributes.map((attribute) => ({
          label: attribute.nm_alias || attribute.nm_coluna,
          value: attribute.nm_coluna,
        }))}
      />

      <Styled.ApplyButton onClick={handleApplyDissolveLayer}>
        Aplicar dissolve
      </Styled.ApplyButton>
    </ToolBox>
  );
}